import {
  AdminLegendVariant,
  IAdminMultipleAvailabilityCalendar,
  ICalendarEventType,
  multipleAvails,
} from '@pharmaplan/common';
import { renderScreen, setOpen } from '../../actions/drawerActions';
import { ScreenTypes } from '../../helpers/Constants';
import { getMultipleEventAdd } from '../../selectors/calendarSelector';
import { useAppDispatch } from '../useAppDispatch';
import { useAppSelector } from '../useAppSelector';

const { posted, requested, booked } = AdminLegendVariant;
const { availableWorkshift, bookingList } = ScreenTypes;

const getMultipleAvailabilityEventIds = (
  events: Array<IAdminMultipleAvailabilityCalendar>,
  eventType: ICalendarEventType,
  date?: string,
) => {
  if (!date) {
    return [];
  }

  const selectedDate = date.split('T')[0];
  const eventIdKey = eventType === booked ? 'bookingId' : 'workShiftId';

  return [
    ...new Set(
      events
        .filter(
          (event) =>
            event.type === eventType
            && event.startDate.split('T')[0] === selectedDate,
        )
        .map((event) =>
          event[eventIdKey])
        .filter(Boolean),
    ),
  ];
};

interface IHandleNavigation {
  id: string;
  pharmacyId: string;
  eventType: ICalendarEventType;
  date?: string;
  workshiftId?: string;
  isAutoSyncRecord?: boolean;
}

const useDetailsNavigation = () => {
  const dispatch = useAppDispatch();
  const isMultipleAdd = useAppSelector(getMultipleEventAdd);
  const multipleAvailabilities = useAppSelector(multipleAvails);

  const handleNavigation = ({
    id,
    pharmacyId,
    eventType,
    date,
    workshiftId,
    isAutoSyncRecord,
  }: IHandleNavigation) =>
    () => {
      const isMultipleAvailabilityList = isMultipleAdd
        && (eventType === requested || eventType === booked);
      const multipleAvailabilityEventIds = isMultipleAvailabilityList
        ? getMultipleAvailabilityEventIds(
          multipleAvailabilities,
          eventType,
          date,
        )
        : [];
      const fallbackEventId = eventType === booked ? id : workshiftId;
      let eventIds = multipleAvailabilityEventIds;

      if (
        isMultipleAvailabilityList
        && eventIds.length === 0
        && fallbackEventId
      ) {
        eventIds = [fallbackEventId];
      }

      switch (eventType) {
        case posted:
          dispatch(
            renderScreen({
              screenNumber: 3,
              screenType: availableWorkshift,
              eventId: id,
              type: posted,
              pharmacyId,
              date,
              extraParameters: {
                isAutoSyncRecord,
              },
            }),
          );
          break;
        case requested:
          dispatch(
            renderScreen({
              screenNumber: 1,
              screenType: ScreenTypes.requestedList,
              date,
              eventIds,
              extraParameters: {
                isAutoSyncRecord,
              },
            }),
          );
          break;
        case booked:
          dispatch(
            renderScreen({
              screenNumber: isMultipleAvailabilityList ? 1 : 2,
              screenType: bookingList,
              eventId: id,
              date,
              eventIds,
              extraParameters: {
                isAutoSyncRecord,
              },
            }),
          );
          break;
        default:
          break;
      }
      dispatch(setOpen(true));
    };
  return { handleNavigation };
};

export default useDetailsNavigation;
